import React, { Component } from "react";
import { connect } from "react-redux";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { PORT } from "../../config/config";
import DebtorsReport from "./DebtorsReport";
import DebtorTrackPayment from "./DebtorTrackPayment";

class DebtorsReportTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      activeTab: "1",
      menuID: [805],
      grouppermissions: [],
    };

    this.toggle = this.toggle.bind(this);
    this.loadGroupPermission = this.loadGroupPermission.bind(this);
  }

  componentWillMount() {
    this.setState({
      user: JSON.parse(this.props.user),
    });
  }

  componentDidMount() {
    this.loadGroupPermission();
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  loadGroupPermission() {
    let type = this.props.type;
    let menuID = this.state.menuID;
  }

  render() {
    return (
      <div className="col-md-12">
        <Nav tabs>
          <>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "1" })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                <i className="icon-options-vertical" /> ข้อมูลลูกหนี้
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "2" })}
                onClick={() => {
                  this.toggle("2");
                }}
              >
                <i className="icon-user-follow" /> ติดตามการรับชำระเงิน
              </NavLink>
            </NavItem>
          </>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <DebtorsReport />
          </TabPane>

          <TabPane tabId="2">
            <DebtorTrackPayment/>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  type: state.auth.type,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(DebtorsReportTab);
